// extracted by mini-css-extract-plugin
export var quantityInput = "_pd-0";